<section id="select">
  <div class="blockcode pt-5">
    <div class="header">Select</div>
    <div class="example">
      <CDBSelect [options]="option" selected="Choose an option"></CDBSelect>
    </div>
  </div>
</section>
